import NewModal from './NewModal';
export default NewModal;
